import { createFileRoute } from '@tanstack/react-router';
import { AdminFuelSurchargeImportPage } from '@/features/admin/admin-fuel-surcharge-import-page';

export const Route = createFileRoute('/admin/fuel-surcharge/import')({
  component: AdminFuelSurchargeImportRoute,
});

function AdminFuelSurchargeImportRoute() {
  return <AdminFuelSurchargeImportPage />;
}
